import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: ${tokens.typography.fontFamily.primary};

  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${color.text.label};
  }
`

// La hora no lleva etiqueta propia: se alinea con la fecha por la base
export const DateRow = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`

export const DateField = styled.div`
  width: 200px;
`

export const TimeField = styled.div`
  width: 140px;
`

export const DefaultMessagesLink = styled.button`
  align-self: flex-end;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.primary || color.brand.primary};
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`
